import React, { useContext } from "react";

import classNames from "classnames";
import Image from "next/legacy/image";

import { useAppState } from "../../../contexts/ApplicationStateProvider";
import ComponentContext from "../../../contexts/ComponentContext";
import Markdown from "../../styles/Markdown";
import LocaleSelector from "../LocaleSelector/LocaleSelector";

function ImageWithDescription() {
  const {
    image,
    imagePosition,
    text,
    textClassName,
    showImageOnMobile,
    showLocaleSwitch,
  } = useContext(ComponentContext);

  const { isMobile } = useAppState();

  const className = classNames("d-flex row", {
    "flex-column-reverse": isMobile,
    "flex-row-reverse": imagePosition === "left",
    "gap-3": isMobile,
  });
  const imageSection = (
    <div className="d-flex col-md-6 align-self-center justify-content-center">
      <Image
        alt={image?.alternativeText}
        height={image?.height}
        src={image?.url}
        width={image?.width}
      />
    </div>
  );

  const mobileImageSection =
    showImageOnMobile && imageSection ? imageSection : null;

  return (
    <div className={className}>
      <div className="px-5 col-md-6 d-flex flex-column justify-content-center">
        <div className="textBlock">
          <div className="mb-5">
            <Markdown className={textClassName}>{text}</Markdown>
          </div>

          {showLocaleSwitch && (
            <LocaleSelector
              flagHeight={48}
              flagWrapperClassName="me-4"
              showAllLocales
            />
          )}
        </div>
      </div>
      {isMobile ? mobileImageSection : imageSection}
    </div>
  );
}

export default ImageWithDescription;
